import { useCallback, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useAuth } from "../use-auth";
import { promiseFetchDataAuth } from 'crk-front-lib';
// eslint-disable-next-line no-unused-vars
import { showAlert } from '../zeta-widget/tools/alert-tool';
import { translateErrorMessage, validate } from '../controllers/register';
import { keepUserDataLocalStorage } from 'crk-front-lib';

const { URL_SIGNUP } = require('../configs/constant.json');

export function RegisterPage(props) {
  const auth = useAuth();
  const history = useHistory();

  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const app_id = search.get('app');
  const from_page = search.get('from');

  const [labelMessage, setLabelMessage] = useState({
    text: '',
    classes: ''
  })

  const handleRegister = useCallback(() => {
    if (window.opener && !window.appWindow) {
      window.appWindow = window.opener;
    }

    const form = new FormData(document.getElementById('regisForm'));

    let _data = {
      email: form.get('email'),
      fullname: form.get('fullname'),
      password: form.get('password'),
      repeat: form.get('repeat'),
      captcha: form.get('captcha')
    };

    if ( !validate(_data, setLabelMessage) ) return;
        
    // console.info(_data, form);
    promiseFetchDataAuth(URL_SIGNUP, 'POST', _data)
    .then(result => {
      console.info(result);
      keepUserDataLocalStorage(result);
      auth.signin(result.user);
      /*
      if (window.opener) {
        window.opener.postMessage(result, '*');
      }
      */
      if (app_id) {
        window.opener.postMessage({...result, from: 'signup'}, '*');
        history.push(`/subscribe/${app_id}`);
      } else if (from_page) {
        history.goBack();
      } else if (window.opener) {
        window.opener.postMessage(result, '*');
        window.close();
      } else {
        history.push('/secure');
      }
    })
    .catch(err => {
      let _msg = ''
      if (typeof err === 'string') {
        _msg = translateErrorMessage(err);
        showAlert(_msg);
      } else {
        console.error(err);
      }

      if (_msg === '') _msg = 'ป้อนข้อมูลไม่ถูกต้อง';

      setLabelMessage({
        text: _msg,
        classes: 'text-danger',
      });
    })
    
  }, [app_id, auth, from_page, history]);

  const handleResetCaptcha = useCallback(() => {
    const _img = document.getElementById('img_captcha');
    _img.src = '/api/v2/captcha?t=' + new Date().getTime();
  }, []);

  return (
    <div className="row justify-content-center">
      <div className="col-xl-10 col-md-12 col-md-9">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            {/* Nested Row within Card Body */}
            <div className="row p-3">
              <div className="col-lg-5 d-none d-lg-block bg-register-image my-1"></div>
              <div className="col-lg-7">
                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-4">Create an Account!</h1>
                  </div>
                  <form id='regisForm' className="user">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-user"
                        name="fullname"
                        placeholder="Full Name"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-user"
                        name="email"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="password"
                          className="form-control form-control-user"
                          name="password"
                          placeholder="Password"
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="password"
                          className="form-control form-control-user"
                          name="repeat"
                          placeholder="Repeat Password"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          name="captcha"
                          placeholder="Secure Code"
                        />                        
                      </div>
                      <div className="col-sm-6">
                        ป้อนรหัสความปลอดภัยด้านล่าง
                      </div>
                    </div>
                    <p id='message' className={labelMessage.classes}>{labelMessage.text}</p>
                    <button type="button"
                      onClick={handleRegister} 
                      className="btn btn-primary btn-user btn-block"
                    >
                      Register Account
                    </button>
                    <hr />
                    {/*
                    <a href="index.html" className="btn btn-google btn-user btn-block">
                      <i className="fab fa-google fa-fw"></i> Register with Google
                    </a>
                    <a href="index.html" className="btn btn-facebook btn-user btn-block">
                      <i className="fab fa-facebook-f fa-fw"></i> Register with Facebook
                    </a>
                    */}
                    <img id="img_captcha" src="/api/v2/captcha" alt="captcha" />
                    <button type="button" className="btn" onClick={handleResetCaptcha}>
                      <i className="fas fa-sync-alt"></i>
                    </button>
                    <p>รหัสความปลอดภัย</p>
                  </form>
                  <hr />
                  <div className="text-center">
                    <Link className="small" href="/forgot-password">
                      Forgot Password?
                    </Link>
                  </div>
                  <div className="text-center">
                    <Link className="small" to={"/login" + (app_id ? `?app=${app_id}&from=${from_page || ''}` : '')}>
                      Already have an account? Login!
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-md-8 offset-md-2 ml-xs-4">
                <p>หลังจากลงทะเบียนแล้ว โปรแกรมจะส่งอีเมล์ไปยืนยันการสมัคร ไม่เกิน 1 ชั่วโมง<br />
                  หากเกินเวลาที่แจ้งไว้ กรุณาติดต่อเจ้าหน้าที่</p>
                  <a
                    href="https://web.crksolution.com/#contact"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-sm btn-link"
                  >
                    ติดต่อเจ้าหน้าที่
                  </a>
                  <br />
                  <br />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
